var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("base-tutorial", { attrs: { steps: _vm.steps } }, [
    _c("div", [
      _c("h2", [
        _vm._v(
          " Olá! Na aba UNIDADES PARTICIPANTES você pode analisar cada unidade da estrutura organizacional. "
        ),
      ]),
      _c("div", [
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(" No filtro "),
            _c("b", [_vm._v("“Selecione a unidade”")]),
            _vm._v(
              ", posicionado do lado direito, você seleciona a unidade organizacional que deseja verificar; após efetuar essa escolha aparecerão gráficos e tabelas com dados referentes a composição da equipe da unidade selecionada. "
            ),
          ]
        ),
        _c(
          "p",
          { staticClass: "mx-2 pa-2 text-start font-weight-medium text-lg-h6" },
          [
            _vm._v(
              " Na tabela é possível observar a relação dos servidores da unidade; utilizar os recursos de ordenação, de forma crescente ou decrescente, por nome do servidor, cargo ou função, bem como, realizar pesquisa por qualquer termo constante na tabela. "
            ),
          ]
        ),
      ]),
    ]),
    _c("div", [
      _c("h2", [_vm._v("Importante!")]),
      _c("div", { staticClass: "mx-2 pa-2 justify-center" }, [
        _c("ul", [
          _c("li", [
            _c(
              "p",
              {
                staticClass:
                  "text-start font-weight-medium info--text text-lg-h6",
              },
              [
                _vm._v(
                  " Sugere-se observar a equipe que compõe a unidade, os cargos e as funções. Caso haja alguma inconsistência na lotação dos servidores, recomenda-se procurar a PROGEP. "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }